import { styled } from '@linaria/react';

import MaintenancePicture from './maintenance.inline.svg';

export const ErrorBoundaryWrapper = styled.div`
  display: flex;
  background-color: #fff;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 16px;
`;

export const ErrorBoundaryWrapperSmall = styled(ErrorBoundaryWrapper)`
  border: 1px solid var(--bb-color-basic-2);
  border-radius: var(--bb-global-border-radius);
  flex-direction: row;
  gap: 4px;
  padding: 4px;
`;

export const ErrorBoundaryImg = styled(MaintenancePicture)``;
export const ErrorBoundaryTitle = styled.h1`
  font-size: 22px;
  line-height: 26px;
  color: var(--bb-color-basic-5);
`;
export const ErrorBoundaryText = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: var(--bb-color-basic-4);
`;
